import Vue from "vue";

const setTableHeight = (el, ElTable, isStatic) => {
  return (headerHeight, footerHeight) => {
    // if (window.screen.width < 768) {
    //   tableHeight -= 15;
    // }
    let parent = el.parentElement;
    let hasScroll = parent.scrollHeight > parent.clientHeight;
    while (!hasScroll && parent.parentNode) {
      parent = parent.parentNode;
      hasScroll = parent.scrollHeight > parent.clientHeight;
    }
    let parentHeight = window.innerHeight;

    if (hasScroll) {
      parentHeight = parent.scrollHeight;
    }
    
    let tableHeight = parentHeight - el.offsetTop - footerHeight - headerHeight;

    if (!isStatic) {
      ElTable.layout.setMaxHeight(tableHeight);
    } else {
      ElTable.layout.setHeight(tableHeight);
    }
    ElTable.doLayout();
  };
};
/**
 * el-table 自適應高度設定
 * 前置需要先對el-table設定height/maxHeight
 *
 * @usage
 *   <el-table height="100%" v-table-adaptive="{header: 10, footer: 10}"
 */
Vue.directive("table-adaptive", {
  /**
   *
   * @param {*} el
   * @param {*} binding
   * binding.value = {
   *      header: 0 // 表格頭部預留高度
   *      footer: 0 // 表格底部預留高度
   *      static: true // 為靜態則使用height 否則使用maxHeight
   * }
   * @param {*} vnode
   * @param {*} oldVnode
   */
  update(el, binding, vnode) {
    let headerHeight = !isNaN(binding.value.header) ? binding.value.header : 0;
    let footerHeight = binding.value.footer ? binding.value.footer : 0;

    let table = vnode.componentInstance;
    let isStatic = "static" in binding.value ? binding.value.static : true;
    setTableHeight(el, table, isStatic)(headerHeight, footerHeight);

    // 监听窗口大小变化
    window.addEventListener("resize", () => {
      setTableHeight(el, table, isStatic)(headerHeight, footerHeight);
    });
  },
});
